(function () {
    'use strict';
    angular.module('wamasysApp').factory('NotificationInbox', NotificationInbox);
    NotificationInbox.$inject = ['$rootScope', '$http', '$q', '$interval', '$timeout', '$window', 'Principal', 'AuthServerProvider', 'NotificationProtocol', 'WebNotificationPush'];
    function NotificationInbox($rootScope, $http, $q, $interval, $timeout, $window, Principal, AuthServerProvider, protocol, push) {
        var epoch = 0, context, canceler, poll, reconnect, expiryTimer, stream, seen = {}, refreshing;
        var state = {unreadCount: 0, messages: [], toast: null, connected: false, active: false, revision: null};
        var service = {state: state, page: page, find: find, read: read, refresh: summary,
            generation: function () { return epoch; }, prepareLogout: stop,
            enablePush: function () { return push.enable(context); },
            disablePush: function () { return push.disable(context); }, push: push.state};
        $rootScope.$watch(sessionKey, restart);
        return service;

        function sessionKey() {
            var account = Principal.getIdentityIfExist(), token = AuthServerProvider.getToken();
            if (!Principal.isAuthenticated() || !account || account.activated === false || !token) { return ''; }
            return [token, account.id || account.login, account.agence && account.agence.id,
                account.entiteParente && account.entiteParente.id].join('|');
        }
        function current(generation) { return context && epoch === generation && sessionKey() === context.key; }
        function stop() {
            var previous = context;
            epoch++; context = null; seen = {}; refreshing = null;
            if (canceler) { canceler.resolve(); }
            if (stream) { stream.abort(); stream = null; }
            if (poll) { $interval.cancel(poll); poll = null; }
            if (reconnect) { $timeout.cancel(reconnect); reconnect = null; }
            if (expiryTimer) { $timeout.cancel(expiryTimer); expiryTimer = null; }
            state.unreadCount = 0; state.messages = []; state.toast = null; state.connected = false;
            state.active = false; state.revision = null;
            push.disconnect(previous);
            $rootScope.$broadcast('notifications:reset');
        }
        function restart(key) {
            stop();
            if (!key) { return; }
            var account = Principal.getIdentityIfExist();
            context = {key: key, token: AuthServerProvider.getToken(),
                accountKey: [account.id || account.login, account.entiteParente && account.entiteParente.id,
                    account.agence && account.agence.id].join(':'), generation: epoch};
            var expiration;
            try { expiration = JSON.parse($window.atob(context.token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/'))).exp * 1000; }
            catch (ignore) { expiration = 0; }
            if (expiration && expiration <= Date.now()) { stop(); return; }
            if (expiration) { expiryTimer = $timeout(stop, Math.min(expiration - Date.now(), 2147483647)); }
            canceler = $q.defer(); state.active = true;
            push.configure(context, function () { summary(); });
            summary(); openStream(epoch);
            // Le repli reste actif : proxy sans streaming, navigateur ancien ou événement perdu.
            poll = $interval(summary, 30000);
        }
        function request(method, path, body, params) {
            var generation = epoch;
            if (!current(generation)) { return $q.reject({cancelled: true}); }
            return $http({method: method, url: 'api/notifications/' + path, data: body, params: params,
                timeout: canceler.promise, cache: false}).then(function (response) {
                if (!current(generation)) { return $q.reject({cancelled: true}); }
                return response.data;
            }, function (error) {
                if (!current(generation)) { return $q.reject({cancelled: true}); }
                if (error.status === 401 || error.status === 403) { stop(); }
                return $q.reject(error);
            });
        }
        function received(messages) {
            angular.forEach(messages, function (message) {
                if (!message || message.type !== 'VISIBLE' || !protocol.positiveId(message.id)) { return; }
                var key = 'received:' + message.id;
                if (seen[key]) { return; }
                seen[key] = true;
                var generation = epoch;
                request('POST', 'receipt', {messageId: message.id, status: 'RECEIVED'}).catch(function () {
                    if (current(generation)) { delete seen[key]; }
                });
            });
        }
        function page(beforeId) {
            return request('GET', 'inbox', null, {beforeId: beforeId || undefined, size: 30}).then(function (result) {
                result.messages = (result.messages || []).filter(function (message) { return message.type === 'VISIBLE'; });
                received(result.messages); return result;
            });
        }
        function summary() {
            if (!context || refreshing) { return; }
            push.checkPermission();
            var generation = epoch;
            refreshing = request('GET', 'summary').then(function (result) {
                var changed = state.revision !== result.revision;
                var initial = state.revision === null;
                state.unreadCount = result.unreadCount || 0; state.revision = result.revision;
                if (changed || !state.messages.length) {
                    return page().then(function (inbox) {
                        var newMessage;
                        angular.forEach(inbox.messages, function (message) {
                            if (!seen['message:' + message.id] && !message.read && !newMessage) { newMessage = message; }
                            seen['message:' + message.id] = true;
                        });
                        state.messages = inbox.messages;
                        if (!initial && newMessage) { state.toast = {id: newMessage.id}; }
                        $rootScope.$broadcast('notifications:changed');
                    });
                }
            }).catch(angular.noop).finally(function () { if (epoch === generation) { refreshing = null; } });
        }
        function find(id) {
            if (!protocol.positiveId(id)) { return $q.reject({status: 404}); }
            return request('GET', 'inbox/' + id).then(function (message) { received([message]); return message; });
        }
        function read(message) {
            return request('POST', 'receipt', {messageId: message.id, status: 'READ'}).then(function () {
                if (!message.read) { state.unreadCount = Math.max(0, state.unreadCount - 1); }
                message.read = true;
                angular.forEach(state.messages, function (item) { if (item.id === message.id) { item.read = true; } });
                summary();
            });
        }
        function openStream(generation) {
            if (!current(generation) || !$window.fetch || !$window.AbortController || !$window.TextDecoder) { return; }
            stream = new $window.AbortController();
            var controller = stream;
            var parser = protocol.createParser(function (name) {
                if (name === 'inbox-changed') { $rootScope.$evalAsync(function () { if (current(generation)) { summary(); } }); }
            });
            $window.fetch('api/notifications/events', {headers: {Authorization: 'Bearer ' + context.token, Accept: 'text/event-stream'},
                credentials: 'same-origin', cache: 'no-store', signal: controller.signal}).then(function (response) {
                if (!current(generation)) { controller.abort(); return; }
                if (response.status === 401) {
                    $rootScope.$evalAsync(function () { if (current(generation)) { stop(); } }); return;
                }
                // 403 signifie aussi SSE désactivé ou limite de connexions atteinte.
                // La boîte et son repli HTTP restent actifs ; pas de reconnexion en boucle.
                if (response.status === 403) { return; }
                if (!response.ok || !response.body || !response.body.getReader) { throw new Error('Streaming indisponible'); }
                $rootScope.$evalAsync(function () { if (current(generation)) { state.connected = true; } });
                var reader = response.body.getReader(), decoder = new $window.TextDecoder('utf-8');
                function pump() {
                    return reader.read().then(function (chunk) {
                        if (!current(generation)) { return reader.cancel(); }
                        if (chunk.done) { throw new Error('Flux terminé'); }
                        parser.push(decoder.decode(chunk.value, {stream: true})); return pump();
                    });
                }
                return pump();
            }).catch(function () {
                $rootScope.$evalAsync(function () {
                    if (!current(generation)) { return; }
                    state.connected = false;
                    reconnect = $timeout(function () { openStream(generation); }, 10000);
                });
            });
        }
    }
}());
